import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import InfoWindow from 'react-google-maps/lib/components/InfoWindow';
import { Polygon } from 'react-google-maps';
import { getInfoWindowPosition, getShape } from './util';
import { getPaths } from './GeojsonFeature';
import { Card, IconList } from 'common/components';
import { connect } from 'react-redux';
import * as constants from 'common/constants';
import { base64url_encode } from 'util/base64';
import { withRouter } from 'react-router-dom';
import { history, store } from 'store';
import { change, formValueSelector } from 'redux-form';
import { compose } from 'redux';
class PolygonWrapper extends Component {
  state = {
    paths: [],
    infoContent: [],
    editable: false,
    hasCrops: false,
    harvested: false,
    disabled: false, // used for activity form polygon update on crop select
    showTooltip: false,
    fieldLocation: null,
    plantedArea: 0,
    size: {},
    match: {},
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      ...prevState,
      ...nextProps,
    };
  }

  _onPolygonClick = () => {
    const {
      formName,
      infoTitle,
      fieldLocation,
      match,
      selectedCrop,
      size,
      plantedArea,
      geojson,
      paths,
    } = this.state;
    if (
      match.url.match(
        /\/activity\/add\/(HARVESTING|SCOUTING|FERTILIZING|OTHER)/g
      )
    ) {
      const {
        params: { type },
      } = match;
      if (['FERTILIZING', 'SCOUTING', 'OTHER'].includes(type)) {
        store.dispatch(
          change(
            formName,
            'fieldName',
            JSON.stringify({
              name: infoTitle,
            })
          )
        );
        store.dispatch(
          change(
            formName,
            'location',
            `${fieldLocation.lat}, ${fieldLocation.lng}`
          )
        );

        if (type === 'SCOUTING') {
          store.dispatch({
            type: constants.UPDATE_SELECTED_FIELD,
            payload: getShape({ geojson, shape: paths }),
          });
        }
      }
      if (type === 'HARVESTING' && !!selectedCrop) {
        store.dispatch(
          change(
            formName,
            'fieldName',
            JSON.stringify({
              name: infoTitle,
              size: plantedArea || (size && size.size),
            })
          )
        );
      }
    } else {
      const encodedFieldName = base64url_encode(infoTitle.trim());
      if (
        !match.params.encodedFieldName ||
        match.params.encodedFieldName !== encodedFieldName
      ) {
        history.push(`${constants.ROUTE_FIELDS_DETAIL}/${encodedFieldName}`);
      }
    }
  };

  _scoutingMarkerActive = () => {
    const {
      match: {
        params: { type },
      },
      selectedLocation,
    } = this.state;
    const isScouting = type === constants.ACTIVITY_TYPES.SCOUTING;
    return isScouting ? !selectedLocation : true;
  };

  render() {
    const {
      geojson,
      paths,
      editable,
      hasCrops,
      disabled,
      harvested,
      infoContent,
      infoTitle,
      infoSubTitle,
    } = this.state;
    const polygonColor =
      (harvested && '#F9A60E') || (hasCrops && '#9BBB00') || '#C2C2C2';

    return (
      <Fragment>
        <Polygon
          editable={editable}
          paths={geojson ? getPaths(geojson) : paths || []}
          options={{
            strokeColor: '#EAEAEA',
            fillOpacity: disabled ? 0 : 0.8,
            strokeWeight: disabled ? 0 : 1,
            fillColor: polygonColor,
          }}
          onClick={this._onPolygonClick}
          onMouseOver={() => {
            this.setState({ showTooltip: true });
          }}
          onMouseOut={() => {
            this.setState({ showTooltip: false });
          }}
        />
        {this.state.showTooltip && !!infoTitle && this._scoutingMarkerActive() && (
          <InfoWindow
            position={getInfoWindowPosition({ geojson, shape: paths })}
          >
            <Card>
              {infoTitle && <h5 className={'cardlist__title'}>{infoTitle}</h5>}
              {infoSubTitle && (
                <IconList
                  list={[
                    {
                      label: infoSubTitle,
                      icon: 'fields',
                    },
                  ]}
                />
              )}
              {infoContent && infoContent.length > 0 && (
                <IconList
                  list={infoContent.map(line => ({
                    label: line,
                    icon: 'crop',
                  }))}
                />
              )}
            </Card>
          </InfoWindow>
        )}
      </Fragment>
    );
  }
}

PolygonWrapper.propTypes = {
  editable: PropTypes.bool,
  hasCrops: PropTypes.bool,
  infoContent: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.element, PropTypes.string])
  ),
  infoSubTitle: PropTypes.string,
  infoTitle: PropTypes.string,
  geojson: PropTypes.object,
  paths: PropTypes.arrayOf(PropTypes.object),
  polygon: PropTypes.object,
};

const field = formValueSelector('activityform');
const mapState = state => ({
  formName: state.map.formName,
  selectedCrop: field(state, 'crop'),
  selectedYield: field(state, 'yield') || '0',
  selectedLocation: field(state, 'location'),
});

const enhance = compose(
  connect(mapState),
  withRouter
);

export default enhance(PolygonWrapper);



// WEBPACK FOOTER //
// ./src/common/components/MapComponent/PolygonWrapper.js